// Strings for projects; app/i18n.ts merges every module's strings at startup.
const ar = {
  project: {
    firstTitle: "لا مشاريع بعد", firstAction: "أنشئ أول مشروع", firstHint: "المشروع يجمع مهامه وساعات فريقه وتكلفته وفواتيره في مكان واحد.",
    title: "المشاريع", new: "مشروع جديد", fromTemplate: "من قالب", code: "الرمز", codeHint: "حروف إنجليزية قصيرة تسبق أرقام المهام (مثل ALN-12). تُصنع من اسم المشروع إن تُركت فارغة.", name: "اسم المشروع",
    manager: "مدير المشروع", customer: "العميل", start: "البداية", end: "النهاية", billable: "قابل للفوترة",
    hourlyRate: "سعر الساعة", hourlyRateHint: "تُفوتر به ساعات المشروع؛ لكل عضو سعر خاص إن أردت من «الأعضاء».", visibility: "من يرى المشروع", membersOnly: "الأعضاء فقط", company: "كل الشركة",
    members: "الأعضاء", role: "الدور", progress: "الإنجاز", openTasks: "{{count}} مفتوحة", board: "اللوحة",
    list: "القائمة", invoiceTime: "فوترة الساعات", template: "القالب", templates: "القوالب",
    statuses: { active: "نشط", on_hold: "متوقف مؤقتاً", completed: "مكتمل", archived: "مؤرشف" },
    roles: { manager: "مدير", member: "عضو", viewer: "مشاهد" },
    overview: {
      tab: "نظرة عامة", done: "المهام المنتهية: {{done}} من {{total}}", hours: "الساعات المسجلة", ofEstimate: "من أصل {{estimate}} مقدّرة",
      noEstimate: "لا تقديرات على المهام", late: "مهام متأخرة", end: "الموعد النهائي", noEnd: "بلا موعد نهائي", pastEnd: "تجاوز موعده",
      lateTasks: "المتأخرة", soonTasks: "تستحق خلال أسبوعين", nothingLate: "لا مهام متأخرة.", nothingSoon: "لا مهام تستحق خلال أسبوعين.",
      team: "الفريق", openTasks: "مهام مفتوحة", hoursLogged: "ساعات",
    },
  },
  contract: {
    isContract: "عقد مقاولات (مستخلصات)", retention: "ضمان الأعمال المحتجز %", advance: "استقطاع الدفعة المقدمة %", tax: "ضريبة المستخلصات",
    tab: "العقد والمستخلصات", tasks: "المهام", value: "قيمة العقد", claimed: "المُستخلص", held: "ضمان محتجز", recovered: "مستقطع من المقدم",
    released: "فُك الضمان في {{date}}", release: "فك ضمان الأعمال", releaseConfirm: "تسجيل استلام المشروع: يصبح الضمان المحتجز مستحقاً على العميل.",
    boq: "المقايسة (جدول الكميات)", editBoq: "تعديل المقايسة", addItem: "إضافة بند", code: "البند", description: "الوصف", unit: "الوحدة",
    quantity: "الكمية", rate: "الفئة", amount: "القيمة", done: "المنفذ", claims: "المستخلصات", newClaim: "مستخلص جديد", claim: "مستخلص رقم {{n}}",
    periodEnd: "حتى تاريخ", previous: "السابق", cumulative: "الإجمالي حتى الآن", thisClaim: "الحالي", gross: "قيمة الأعمال",
    netDue: "الصافي المستحق", invoice: "إصدار الفاتورة", invoiced: "الفاتورة", draft: "مسودة",
    advanceHint: "سجّل الدفعة المقدمة كدفعة من العميل بلا توزيع، فتُستقطع من كل مستخلص بالنسبة المحددة.",
    emptyBoq: "أضف بنود المقايسة لتبدأ المستخلصات.",
  },
  task: {
    new: "مهمة جديدة", title: "العنوان", assignee: "المكلّف", due: "الاستحقاق", priority: "الأولوية",
    checklist: "قائمة التحقق", subtasks: "مهام فرعية", addItem: "إضافة عنصر", addSubtask: "إضافة مهمة فرعية",
    personal: "مهمة شخصية", overdue: "متأخرة", today: "اليوم", thisWeek: "هذا الأسبوع", later: "لاحقاً", noDate: "بلا تاريخ",
    labels: "الوسوم", estimate: "التقدير (دقائق)",
    priorities: { low: "منخفضة", medium: "متوسطة", high: "عالية", urgent: "عاجلة" },
  },
  taskList: {
    layout: "عرض المهام", key: "الرقم", anyStatus: "كل الحالات", anyone: "كل الأشخاص", unassigned: "غير مسندة", anyPriority: "كل الأولويات",
    anyDate: "أي موعد", nextWeek: "خلال أسبوع", actions: "إجراءات على المحدد", picked: "المحدد: {{count}}",
    assignTo: "إسناد إلى…", moveTo: "نقل إلى…", setPriority: "الأولوية…", setDue: "تحديد الاستحقاق",
    deleteThem: "حذف المهام المحددة ({{count}}) نهائياً؟", changed: "تم تحديث المهام ({{count}})",
  },
  time: {
    title: "سجل الساعات", week: "أسبوع {{date}}", log: "تسجيل وقت", approveAll: "اعتماد الكل", project: "المشروع", task: "المهمة (اختياري)", hoursHint: "ساعات:دقائق، مثل 1:30", minutes: "الدقائق", hours: "الساعات",
    startTimer: "بدء المؤقت", submitWeek: "إرسال الأسبوع للاعتماد", approve: "اعتماد", reject: "رفض",
    rejectReason: "سبب الرفض", pending: "بانتظار الاعتماد", nothingPending: "لا توجد ساعات بانتظار اعتمادك.",
    groupBy: "تجميع حسب", byTask: "المهمة", byPerson: "الشخص", invoiceCreated: "تم إنشاء مسودة فاتورة",
    statuses: { draft: "مسودة", submitted: "مُرسلة", approved: "معتمدة", rejected: "مرفوضة", invoiced: "مفوترة" },
  },
  errors: {
    "project.archived": "المشروع مؤرشف ولا يمكن تعديله؛ غيّر حالته لإعادة فتحه.",
    "project.code_exhausted": "اختر رمزاً للمشروع.",
    "project.code_taken": "رمز المشروع مستخدم.",
    "project.deal_has_project": "لهذه الصفقة مشروع بالفعل.",
    "project.status_in_use": "انقل المهام من الحالة قبل حذفها.",
    "project.statuses_invalid": "أبقِ حالة واحدة على الأقل لكل من: للتنفيذ، قيد التنفيذ، منتهية.",
    "task.personal": "المهام الشخصية ليس لها لوحة.",
    "task.bulk_empty": "اختر ما تريد تغييره في المهام المحددة.",
    "time.not_member": "انضم إلى المشروع لتسجيل وقت عليه.",
    "time.not_submitted": "يمكن اعتماد أو رفض الساعات المرسلة فقط.",
    "timer.not_running": "لا يوجد مؤقت يعمل.",
    "task.open_subtasks": "للمهمة مهام فرعية مفتوحة.",
    "task.assignee_not_member": "المكلّف ليس عضواً في المشروع.",
    "time.too_old": "تسجيل وقت أقدم من 30 يوماً يحتاج مدير المشروع.",
    "time.locked": "الساعات المرسلة أو المعتمدة لا تُعدّل.",
    "time.nothing_to_invoice": "لا توجد ساعات معتمدة قابلة للفوترة في هذه الفترة.",
    "time.no_rate": "الساعات المعتمدة بلا سعر: حدد سعر الساعة للمشروع (تعديل المشروع)، ثم أعد الفوترة.",
    "project.no_customer": "اربط المشروع بعميل قبل الفوترة.",
    "project.not_contract": "المشروع ليس عقد مقاولات.",
    "claim.draft_open": "أكمل المستخلص المسودة أولاً.",
    "claim.invoiced": "صدرت فاتورة هذا المستخلص.",
    "claim.no_customer": "اربط المشروع بعميل أولاً.",
    "claim.empty": "لا توجد أعمال جديدة في المستخلص.",
    "boq.item_claimed": "البند دخل في مستخلص فلا يُحذف من المقايسة.",
  },
};

const en: typeof ar = {
  project: {
    firstTitle: "No projects yet", firstAction: "Create your first project", firstHint: "A project keeps its tasks, its team's hours, its cost and its invoices in one place.",
    title: "Projects", new: "New project", fromTemplate: "From template", code: "Code", codeHint: "A short key in task numbers (like ALN-12). Made from the project's name when empty.", name: "Project name",
    manager: "Manager", customer: "Customer", start: "Start", end: "End", billable: "Billable", hourlyRate: "Hourly rate", hourlyRateHint: "The project's time is invoiced at it; members can have their own under Members.",
    visibility: "Who can see it", membersOnly: "Members only", company: "Whole company", members: "Members", role: "Role",
    progress: "Progress", openTasks: "{{count}} open", board: "Board", list: "List", invoiceTime: "Invoice time",
    template: "Template", templates: "Templates",
    statuses: { active: "Active", on_hold: "On hold", completed: "Completed", archived: "Archived" },
    roles: { manager: "Manager", member: "Member", viewer: "Viewer" },
    overview: {
      tab: "Overview", done: "{{done}} of {{total}} tasks done", hours: "Hours logged", ofEstimate: "of {{estimate}} estimated",
      noEstimate: "No estimates on the tasks", late: "Late tasks", end: "Deadline", noEnd: "No deadline", pastEnd: "Past its deadline",
      lateTasks: "Late", soonTasks: "Due in the next two weeks", nothingLate: "Nothing late.", nothingSoon: "Nothing due in the next two weeks.",
      team: "Team", openTasks: "Open tasks", hoursLogged: "Hours",
    },
  },
  contract: {
    isContract: "Contract (progress claims)", retention: "Retention held %", advance: "Advance recovered %", tax: "Tax on claims",
    tab: "Contract & claims", tasks: "Tasks", value: "Contract value", claimed: "Claimed", held: "Retention held", recovered: "Advance recovered",
    released: "Retention released on {{date}}", release: "Release the retention", releaseConfirm: "Record the handover: the retention held becomes due from the customer.",
    boq: "Bill of quantities", editBoq: "Edit the bill of quantities", addItem: "Add an item", code: "Item", description: "Description", unit: "Unit",
    quantity: "Qty", rate: "Rate", amount: "Amount", done: "Done", claims: "Progress claims", newClaim: "New claim", claim: "Claim no. {{n}}",
    periodEnd: "Up to", previous: "Previous", cumulative: "To date", thisClaim: "This claim", gross: "Work value",
    netDue: "Net due", invoice: "Invoice it", invoiced: "Invoice", draft: "Draft",
    advanceHint: "Record the advance as a customer payment left unallocated; each claim recovers its share.",
    emptyBoq: "Add the bill of quantities to start claiming.",
  },
  task: {
    new: "New task", title: "Title", assignee: "Assignee", due: "Due", priority: "Priority", checklist: "Checklist",
    subtasks: "Subtasks", addItem: "Add item", addSubtask: "Add subtask", personal: "Personal task", overdue: "Overdue",
    today: "Today", thisWeek: "This week", later: "Later", noDate: "No date", labels: "Labels", estimate: "Estimate (minutes)",
    priorities: { low: "Low", medium: "Medium", high: "High", urgent: "Urgent" },
  },
  taskList: {
    layout: "Task view", key: "Key", anyStatus: "Any status", anyone: "Anyone", unassigned: "Unassigned", anyPriority: "Any priority",
    anyDate: "Any date", nextWeek: "Within a week", actions: "Act on the chosen", picked: "{{count}} chosen",
    assignTo: "Give to…", moveTo: "Move to…", setPriority: "Priority…", setDue: "Set due date",
    deleteThem: "Delete the {{count}} chosen tasks for good?", changed: "{{count}} tasks updated",
  },
  time: {
    title: "Timesheet", week: "Week of {{date}}", log: "Log time", approveAll: "Approve all", project: "Project", task: "Task (optional)", hoursHint: "hours:minutes, like 1:30", minutes: "Minutes", hours: "Hours",
    startTimer: "Start timer", submitWeek: "Submit week for approval", approve: "Approve", reject: "Reject",
    rejectReason: "Reason", pending: "Awaiting approval", nothingPending: "No time is waiting for your approval.",
    groupBy: "Group by", byTask: "Task", byPerson: "Person", invoiceCreated: "Draft invoice created",
    statuses: { draft: "Draft", submitted: "Submitted", approved: "Approved", rejected: "Rejected", invoiced: "Invoiced" },
  },
  errors: {
    "project.archived": "Archived projects are read-only; change the status to reopen.",
    "project.code_exhausted": "Choose a project code.",
    "project.code_taken": "This project code is taken.",
    "project.deal_has_project": "This deal already has a project.",
    "project.status_in_use": "Move the tasks out of a status before removing it.",
    "project.statuses_invalid": "Keep at least one to-do, in-progress and done status.",
    "task.personal": "Personal tasks have no board.",
    "task.bulk_empty": "Choose what to change in the chosen tasks.",
    "time.not_member": "Join the project to log time on it.",
    "time.not_submitted": "Only submitted entries can be approved or rejected.",
    "timer.not_running": "No timer is running.",
    "task.open_subtasks": "This task has open subtasks.",
    "task.assignee_not_member": "The assignee isn't a project member.",
    "time.too_old": "Time older than 30 days needs the project manager.",
    "time.locked": "Submitted or approved time can't be edited.",
    "time.nothing_to_invoice": "No approved billable time in this period.",
    "time.no_rate": "The approved time has no rate: set the project's hourly rate (edit the project), then invoice again.",
    "project.no_customer": "Link the project to a customer before invoicing.",
    "project.not_contract": "The project isn't a contract.",
    "claim.draft_open": "Finish the draft claim first.",
    "claim.invoiced": "This claim is already invoiced.",
    "claim.no_customer": "Link the project to a customer first.",
    "claim.empty": "The claim has no new work.",
    "boq.item_claimed": "An item measured in a claim stays in the bill of quantities.",
  },
};

export const strings = { ar, en };
